// Resolution order:
// Production sheanswers.com uses https://api.sheanswers.com when VITE_API_URL is unset.
//   1. VITE_API_URL env var (explicit override — useful for prod or pinned LAN IP)
//   2. http://<current-hostname>:1337  — auto-uses localhost on PC, LAN IP on phone
const envUrl = import.meta.env.VITE_API_URL as string | undefined

const dynamicHost =
  typeof window !== 'undefined' ? window.location.hostname : 'localhost'

const isProductionFrontend =
  dynamicHost === 'sheanswers.com' || dynamicHost.endsWith('.sheanswers.com')

export const STRAPI_BASE_URL =
  envUrl?.replace(/\/api\/?$/, '') ||
  (isProductionFrontend ? 'https://api.sheanswers.com' : `http://${dynamicHost}:1337`)

export const API_BASE_URL = `${STRAPI_BASE_URL}/api`

export const API_CONFIG = {
  baseURL: API_BASE_URL,
  timeout: 10000,
} as const
